import { _is_bomlevel_valid, _is_graphlevel_valid, _detect_graphlevel, _detect_parent_bomlevel, _detect_bomlevel_on_graphlevel, _get_next_children_bomlevel, _get_next_sibling_bomlevel, _get_next_bomlevel_on_graphlevel, _merge_bomlevel_as_child, _merge_bomlevel_as_sibling, _get_next_bom_row_smart, _is_bomlevel1_ancestor_of_bomlevel2, _detach_bomlevel, _is_next_bomlevel_valid, _is_next_graphlevel_valid, } from "./frfr-bomlevel-utils";
import { SLASH } from "./frfr-string-consts";


/*
FrFr FRIENDLY FRAMEWORK
frfr-virbom-manipulator-utils
Version ID: 1a 2024-04-03r1
by 
// Please describe here if you customized this file
*/


/*
TODO parent_virtel.graphpath
sta da radi u slucaju kad nema parenta

Kada se pokusa dodati virtel koji nema ispravno napisan bomlevel???????

*/

/*
Dozvoljen REDOSLED dodavanja virtela u virbom je sledeci:
1)
add as first virtel // "1"
add on top graphlevel (graphlevel 1) // "2"
2) add as last virtel children // "2.1"
3) add as last virtel sibling // "2.2"
4) add after last virtel on particular graphlevel
example: posle "2.2" dozvoljeni su "3" ili "2.3" ili "2.2.1"
example: posle "1.2.3" dozvoljeni su "2" ili "1.3" ili "1.2.4" ili "1.2.3.1"

*/

/*
ZAHTEVI

<p>- <b>Kod virbom_members sekvence redosled MORA biti takav da dobijemo isti redosled posećivanja članova niza kao što bi dobili sa tree traversal sa Depth-first search (DFS) algoritmom. Drugim rečima, za posećivanje člonova virbom_members sekvence pravilnim redosledom ne moramo uopšte da koristimo tree traversal. To je ujedno standardni redosled redova u tabelama Multi-level BOM (Bill of materials) sastavnica.</b></p>



TODO parent_subkey na top levelu???? da li treba da bude ili da uvek bude null??

*/

/*
DOKUMENTACIJA - pregled metoda:

- 


PROBLEMATIKA - PITANJA: 

- Da li je moguce da se zadrzi isti subkey od draftela koji se prtvara u jednan virtel a da samo novi kreirani virteli dobiju nove subkey-eve?
Da li mi resetujemo counter kada izvrsimo unload virboma iz draft statea?
Da li mi pri svakom load virboma izvrismo detect max subkey i updateSmart countera?

- 
*/


const _is_arr_not_empty = (arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    return true;
  }
  return false;
};


export const _virbom_validator_quick_incomplete = (virbom_seq) => {
  let valid = true;
  // TEST 1)
  if (Array.isArray(virbom_seq)) {
    // is valid so far
  } else {
    // TEST 1 FAIL
    valid = false;
    // console.log('INVALID - virbom_seq not array');
  }
  return valid;
};


export const _virbom_validator = (virbom_seq) => {
  console.log('*** _virbom_validator(virbom_seq) ');
  let valid = true;
  // TEST 1)
  if (Array.isArray(virbom_seq)) {
    if (virbom_seq.length > 0) {
      // TEST 2) first virtel
      if (virbom_seq[0] && virbom_seq[0].subkey > 0 && virbom_seq[0].parent_subkey === null && virbom_seq[0].bomlevel === '1') {
        // TEST 3) each virtel
        //
        let _prev_bomlevel = false;
        virbom_seq.forEach((virtel, index) => {
          if (_is_bomlevel_valid(virtel.bomlevel)) {
            //
            if (index === 0 || (index > 0 && (_is_next_bomlevel_valid(_prev_bomlevel, virtel.bomlevel)))) {
              // bomlevel validan kao next od _prev_bomlevel
              //
              if (virtel.graphlevel > 0) {
                //
                if (virtel.subkey > 0) {
                  if (virtel.graphlevel === 1) {
                    // virtel on root graphlevel 1
                    if (virtel.parent_subkey === null) {
                      //
                      if (_detect_graphlevel(virtel.bomlevel) === 1) {
                        // VALID
                      } else {
                        // * FAIL
                        valid = false;
                        console.log('* INVALID virtel - index', index, 'INVALID bomlevel is not correct for graphlevel 1', virtel.bomlevel, virtel);
                      }
                    } else {
                      // * FAIL
                      valid = false;
                      console.log('* INVALID virtel - index', index, 'INVALID parent_subkey on graphlevel 1', virtel.parent_subkey, virtel);
                    }
                  } else {
                    // deep virtel
                    //
                    if (virtel.parent_subkey > 0) {
                      //
                      if (virtel.graphlevel === _detect_graphlevel(virtel.bomlevel)) {
                        //
                        const parent_bomlevel = _detect_parent_bomlevel(virtel.bomlevel);
                        const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_seq, parent_bomlevel);
                        if (parent_virtel) {
                          if (virtel.parent_subkey === parent_virtel.subkey) {
                            // VALID
                          } else {
                            // * FAIL
                            valid = false;
                            console.log('* INVALID virtel - index', index, 'INVALID virtel.parent_subkey !== parent_virtel.subkey', virtel.parent_subkey, parent_virtel.subkey, virtel, parent_virtel);
                          }
                        } else {
                          // * FAIL
                          valid = false;
                          console.log('* INVALID virtel - index', index, 'INVALID parent_bomlevel not exist', parent_bomlevel, virtel);
                        }
                      } else {
                        // * FAIL
                        valid = false;
                        console.log('* INVALID virtel - index', index, 'INVALID bomlevel is not correct for graphlevel', virtel.bomlevel, virtel.graphlevel, virtel);
                      }
                    } else {
                      // * FAIL
                      valid = false;
                      console.log('* INVALID virtel - index', index, 'INVALID parent_subkey on graphlevel > 1', virtel.parent_subkey, virtel);
                    }
                    //
                  } // end of deep virtel
                } else {
                  // * FAIL
                  valid = false;
                  console.log('* INVALID virtel - index', index, 'INVALID subkey', virtel.subkey, virtel);
                }
              } else {
                // * FAIL
                valid = false;
                console.log('* INVALID virtel - index', index, 'INVALID graphlevel', virtel.subkey, virtel);
              }
              //
              //
            } else {
              // * FAIL
              valid = false;
              console.log('* INVALID virtel - index', index, 'INVALID bomlevel is not valid as next bomlevel - _prev_bomlevel', _prev_bomlevel, 'this bomlevel', virtel.bomlevel, virtel);
            }
          } else {
            // * FAIL
            valid = false;
            console.log('* INVALID virtel - index', index, 'INVALID bomlevel', virtel.bomlevel, virtel);
          }
          //
          // preparing for next iteration
          _prev_bomlevel = virtel.bomlevel;
        }); // end of forEach
        // finished each virtel
        if (valid) {
          console.log('Every virtel is valid. TEST 3 finished.');
        } else {
          console.log('INVALID - There is INVALID virtel in virbom_seq. TEST 3 FAIL.');
        }
        // TEST 3) each virtel FINISHED
        //
      } else {
        // TEST 2 FAIL
        valid = false;
        console.log('INVALID - first virtel is not valid - we checked: subkey, parent_subkey, bomlevel');
      }
    } else {
      console.log('virbom_seq is empty');
    }
  } else {
    // TEST 1 FAIL
    valid = false;
    console.log('INVALID - virbom_seq not array');
  }
  //
  if (valid) {
    console.log('VALID virbom_seq :) - _virbom_validator finished');
  } else {
    console.log('ERROR INVALID virbom_seq - _virbom_validator finished');
  }
  return valid;
};


export const _virbom_manipulator = {};


_virbom_manipulator._generate_fresh_subkey = null;


_virbom_manipulator.init = (_generate_fresh_subkey) => {
  // REDOSLED 1.
  //
  _virbom_manipulator._generate_fresh_subkey = _generate_fresh_subkey;
  //
  const new_virbom_ref = []; // NEW ARRAY REFERENCE
  return new_virbom_ref;
};


_virbom_manipulator.deinit = (virbom_ref) => {
  // ONLY FOR INSTANCES
  _virbom_manipulator._generate_fresh_subkey = null;
  // DEREFERENCE ARRAY
  // _virbom_manipulator.virbom_ref = []; // REFERENCE TODO
  const virbom_dereferenced = [...virbom_ref]; // NEW ARRAY REFERENCE
  virbom_ref = []; // DEREFERENCED
  return virbom_dereferenced;
};
_virbom_manipulator.deinit_old = () => {
  // ONLY FOR INSTANCES
  // DEREFERENCE ARRAY
  // _virbom_manipulator.virbom_ref = []; // REFERENCE TODO
  _virbom_manipulator._generate_fresh_subkey = null;
};


_virbom_manipulator._record_virtel = (virbom_ref, virtel) => {
  // DIRTY
  if (Array.isArray(virbom_ref)) {
    // virbom_ref.push(virtel);
    //
    // FIX BUDZENJE
    const _prepared_virtel = {
      ...virtel
    };
    // uklanjamo polja koja nikada ne smeju da budu deo virtela
    delete _prepared_virtel._draftelschemakey;
    delete _prepared_virtel._subform_arr;
    //
    virbom_ref.push(_prepared_virtel);
    return true;
  }
  return false;
};


// ----- SELECTOR METHODS -----


/*
_virbom_manipulator.get_virbom_ref = (virbom_ref) => {
  // ONLY FOR INSTANCES
  // DIRTY
  return virbom_ref;
};
*/


_virbom_manipulator.get_first_virtel = (virbom_seq) => {
  if (Array.isArray(virbom_seq)) {
    if (virbom_seq[0]) {
      return virbom_seq[0];
    }
  }
  return false;
};


_virbom_manipulator.get_last_virtel = (virbom_seq) => {
  if (Array.isArray(virbom_seq)) {
    if (virbom_seq[virbom_seq.length - 1]) {
      return virbom_seq[virbom_seq.length - 1];
    }
  }
  return false;
};


_virbom_manipulator.get_virtel_where_bomlevel = (virbom_seq, bomlevel) => {
  // optimized
  if (_is_arr_not_empty(virbom_seq) && _is_bomlevel_valid(bomlevel)) {
    let bingo_virtel = false;
    let finished = false;
    let i = 0;
    let maxi = virbom_seq.length - 1;
    while (i <= maxi && finished === false) {
      const virtel = virbom_seq[i];
      if (bomlevel === virtel.bomlevel) {
        bingo_virtel = virtel;
        finished = true;
      }
      i++;
    } // end of while
    return bingo_virtel;
  }
  return false;
};


_virbom_manipulator._get_parent_graphpath_smart = (virbom_seq, bomlevel) => {
  if (_is_arr_not_empty(virbom_seq)) {
    let graphpath = '';
    const parent_bomlevel = _detect_parent_bomlevel(bomlevel); // bomlevel will alse be validated
    if (_is_bomlevel_valid(parent_bomlevel)) {
      const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_seq, parent_bomlevel);
      if (parent_virtel && parent_virtel.graphpath) {
        graphpath = parent_virtel.graphpath;
      }
    }
    return graphpath;
  }
  return false;
};


// ----- ADD METHODS -----


_virbom_manipulator.add_as_first_virtel = (virbom_ref, virtel) => {
  // REDOSLED 1.
  if (Array.isArray(virbom_ref)) {
    const bomlevel = '1'; // first bomlevel "1"
    const graphlevel = _detect_graphlevel(bomlevel);
    const graphpath = SLASH + virtel.virtelschemakey; // ???
    const parent_subkey = null; // first virtel has no parent
    const new_virtel = {
      ...virtel,
      parent_subkey,
      bomlevel,
      graphlevel,
      graphpath,
    };
    _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
    return new_virtel;
  }
  return false;
};


_virbom_manipulator.add_as_last_virtel_children = (virbom_ref, virtel) => {
  // REDOSLED 2.
  if (_is_arr_not_empty(virbom_ref)) {
    const last_virtel = _virbom_manipulator.get_last_virtel(virbom_ref);
    if (last_virtel !== false) {
      const last_bomlevel = last_virtel.bomlevel;
      if (_is_bomlevel_valid(last_bomlevel)) {
        const parent_subkey = last_virtel.subkey;
        const bomlevel = _get_next_children_bomlevel(last_bomlevel); // last_bomlevel + DOT + 1;
        const graphlevel = _detect_graphlevel(bomlevel);
        const graphpath = last_virtel.graphpath + SLASH + virtel.virtelschemakey; // ???
        const new_virtel = {
          ...virtel,
          parent_subkey,
          bomlevel,
          graphlevel,
          graphpath,
        };
        _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
        return new_virtel;
      }
    }
  }
  return false;
};


_virbom_manipulator.add_as_last_virtel_sibling = (virbom_ref, virtel) => {
  // REDOSLED 3.
  if (_is_arr_not_empty(virbom_ref)) {
    const last_virtel = _virbom_manipulator.get_last_virtel(virbom_ref);
    if (last_virtel !== false) {
      const last_bomlevel = last_virtel.bomlevel;
      const graphlevel = _detect_graphlevel(last_bomlevel); // bomlevel will also be validated
      if (graphlevel !== false) {
        if (graphlevel === 1) {
          return _virbom_manipulator.add_on_top_graphlevel(virbom_ref, virtel);
        } else {
          // CASE not top graphlevel
          const parent_bomlevel = _detect_parent_bomlevel(last_bomlevel);
          const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, parent_bomlevel); // bomlevel will alse be validated
          if (parent_virtel !== false) {
            const parent_subkey = parent_virtel.subkey;
            const bomlevel = _get_next_sibling_bomlevel(last_bomlevel);
            const graphpath = _virbom_manipulator._get_parent_graphpath_smart(virbom_ref, bomlevel) + SLASH + virtel.virtelschemakey; // ???
            const new_virtel = {
              ...virtel,
              parent_subkey,
              bomlevel,
              graphlevel,
              graphpath,
            };
            _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
            return new_virtel;
          }
        }
      } else {
        return false; // invalid graphlevel or bomlevel
      }
    }
  }
  return false;
};


_virbom_manipulator.add_on_top_graphlevel = (virbom_ref, virtel) => {
  // REDOSLED 1.
  if (Array.isArray(virbom_ref)) {
    const last_virtel = _virbom_manipulator.get_last_virtel(virbom_ref);
    if (last_virtel === false) { // TODO možda je bolje da se proverava da li je array prazan?
      // CASE there is no previous virtel
      return _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);
    } else {
      // CASE last virtel exist
      const last_bomlevel = last_virtel.bomlevel;
      if (_is_bomlevel_valid(last_bomlevel)) {
        const last_sibling_bomlevel = _detect_bomlevel_on_graphlevel(last_bomlevel, 1);
        if (_is_bomlevel_valid(last_sibling_bomlevel)) { // just in case - ovo bi uvek trebalo da je validno
          const last_sibling_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, last_sibling_bomlevel);
          if (last_sibling_virtel !== false) {
            //
            // const parent_subkey = null;
            // Iako bi svi virteli na top graphlevel trebali da imaju parent_subkey null, ipak ćemo ga kopirati od njegovog siblinga jer u svakom slučaju treba da svi virteli na top graphlevel da imaju isti parent_subkey
            const parent_subkey = last_sibling_virtel.parent_subkey; //
            //
            const bomlevel = _get_next_sibling_bomlevel(last_sibling_bomlevel);
            const graphlevel = _detect_graphlevel(bomlevel);
            const graphpath = _virbom_manipulator._get_parent_graphpath_smart(virbom_ref, bomlevel) + SLASH + virtel.virtelschemakey; // ???
            const new_virtel = {
              ...virtel,
              parent_subkey,
              bomlevel,
              graphlevel,
              graphpath,
            };
            _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
            return new_virtel;
          } else {
            return false; // ??? last_sibling_virtel not exist ???
          }
        }
      } else {
        return false; // invalid last_bomlevel
      }
    }
  }
  return false;
};


_virbom_manipulator.add_on_graphlevel = (virbom_ref, virtel, graphlevel) => {
  // REDOSLED 4.
  if (_is_graphlevel_valid(graphlevel)) {
    if (graphlevel === 1) {
      // CASE top graphlevel
      // Za top graphlevel nije važno ako je array prazan ili ne jer virteli na top graphlevel nemaju parente.
      return _virbom_manipulator.add_on_top_graphlevel(virbom_ref, virtel);
    } else {
      // CASE not top graphlevel
      if (_is_arr_not_empty(virbom_ref)) {
        const last_virtel = _virbom_manipulator.get_last_virtel(virbom_ref);
        if (last_virtel !== false && last_virtel.bomlevel && _is_bomlevel_valid(last_virtel.bomlevel)) {
          const last_bomlevel = last_virtel.bomlevel;
          const next_bomlevel = _get_next_bomlevel_on_graphlevel(last_bomlevel, graphlevel); // _is_next_graphlevel_valid will also be checked
          if (_is_bomlevel_valid(next_bomlevel)) {
            const parent_bomlevel = _detect_parent_bomlevel(next_bomlevel);
            const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, parent_bomlevel);
            if (parent_virtel !== false) {
              const parent_subkey = parent_virtel.subkey;
              const bomlevel = next_bomlevel;
              const graphlevel = _detect_graphlevel(bomlevel);
              const graphpath = _virbom_manipulator._get_parent_graphpath_smart(virbom_ref, bomlevel) + SLASH + virtel.virtelschemakey; // ???
              const new_virtel = {
                ...virtel,
                parent_subkey,
                bomlevel,
                graphlevel,
                graphpath,
              };
              _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
              return new_virtel;
            } else {
              return false; // invalid parent_virtel, a graphlevel je veci od 1 što znači da je neophodno da ima parent.
            }
          } else {
            return false; // invalid bomlevel or next_graphlevel is not allowed
          }
        } else {
          return false; // ERROR ne postoji validan last_virtel što znači da je nemoguće odrediti validan parent, a graphlevel je veci od 1 što znači da je neophodno da ima parent.
        }
      } else {
        return false; // ERROR virbom_ref je prazan, a graphlevel je veci od 1 što znači da je neophodno da ima parent a u praznom nizu definitivno ne može da postoji parent.
      }
    }
  }
  return false; // invalid graphlevel
};




// ----- MERGE & DETACH METHODS -----


//
const _merge_virbom_into_empty_virbom = (virbom_ref, slave_virbom_seq, _generate_fresh_subkey) => {
  console.log('_merge_virbom_into_empty_virbom - virbom master is empty');
  // NOVO
  //
  // console.log('test merge', "2.1.5", "3.6");
  // console.log('test result merge as child', _merge_bomlevel_as_child("2.1.5", "3.6"));
  // console.log('test result merge as sibling', _merge_bomlevel_as_sibling("2.1.5", "3.6"));
  if (!_is_arr_not_empty(virbom_ref)) {
    if (_is_arr_not_empty(slave_virbom_seq)) {
      if (true) {
        //
        const _cb_get_bom_row = (bomlevel) => {
          return _virbom_manipulator.get_virtel_where_bomlevel(slave_virbom_seq, bomlevel);
        }
        //
        let slave_bomlevel = null; // inital
        let exit = false;
        while (exit === false) {
          // console.log('slave_bomlevel', slave_bomlevel);
          const [next_bomlevel, next_bom_row] = _get_next_bom_row_smart(slave_bomlevel, _cb_get_bom_row);
          if (next_bom_row !== false) {
            slave_bomlevel = next_bomlevel; // for next iteration
            const virtel = next_bom_row;
            let bomlevel;
            bomlevel = slave_bomlevel;
            /*
            if (_is_next_bomlevel_valid(last_valid_bomlevel, bomlevel)) {
              // bomlevel will also be validated
              // everything valid
            } else {
              // ERROR: there is invalid next bomlevel
              console.log('INVALID next bomlevel:', last_valid_bomlevel, bomlevel)
              exit = true;
            }
            */
            //
            if (_is_bomlevel_valid(bomlevel)) { //
              const parent_bomlevel = _detect_parent_bomlevel(bomlevel);
              let parent_subkey = null;
              if (_is_bomlevel_valid(parent_bomlevel)) {
                const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, parent_bomlevel);
                if (parent_virtel !== false) {
                  parent_subkey = parent_virtel.subkey;
                }
              }
              const graphlevel = _detect_graphlevel(bomlevel);
              const graphpath = _virbom_manipulator._get_parent_graphpath_smart(virbom_ref, bomlevel) + SLASH + virtel.virtelschemakey; // ???
              let subkey = null;
              if (typeof _generate_fresh_subkey === 'function') {
                // Ukoliko je primljen callback _generate_fresh_subkey kao argment, onda pri merge-ovanju svi virteli iz slave_virbom_seq dobijaju nove subkey-eve.
                subkey = _generate_fresh_subkey();
              } else {
                // svi zadržavaju subkey-eve kakvi jesu
                subkey = virtel.subkey;
              }
              const new_virtel = {
                ...virtel,
                subkey,
                parent_subkey,
                bomlevel,
                graphlevel,
                graphpath,
              };
              // ADD THIS VIRTEL TO END
              _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
              // last_valid_bomlevel = bomlevel;
            }
          } else {
            exit = true;
            // ako ne postoji next_bom_row virtel
            exit = true; // zavrsili smo sa prolaskom kroz sve virtele od slave_virbom_seq
          }
          // REPEAT
        } // end of while
      } else {
        return false; // ERROR *
      }
      //
      // FINISHED _merge_virbom_into_empty_virbom
      return true;
    } else {
      return false; // ERROR slave virbom is empty. Nothing to merge.
    }
  } else {
    return false; // ERROR master virbom is not empty. Nothing to merge.
  }
  return false;
};


// NOVI USISIVAC
_virbom_manipulator._merge_virbom_into_virbom_where_bomlevel = (virbom_ref, master_bomlevel, mode_as_sibling, slave_virbom_seq, _generate_fresh_subkey) => {
  // NOVI USISIVAC
  //
  // console.log('test merge', "2.1.5", "3.6");
  // console.log('test result merge as child', _merge_bomlevel_as_child("2.1.5", "3.6"));
  // console.log('test result merge as sibling', _merge_bomlevel_as_sibling("2.1.5", "3.6"));
  if (_is_arr_not_empty(virbom_ref) && _is_arr_not_empty(slave_virbom_seq)) {
    if (_is_bomlevel_valid(master_bomlevel)) {
      const master_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, master_bomlevel);
      if (master_virtel !== false) {
        //
        const _cb_get_bom_row = (bomlevel) => {
          return _virbom_manipulator.get_virtel_where_bomlevel(slave_virbom_seq, bomlevel);
        }
        //
        let last_valid_bomlevel = master_bomlevel;
        let slave_bomlevel = null; // inital
        let exit = false;
        while (exit === false) {
          // console.log('slave_bomlevel', slave_bomlevel);
          const [next_bomlevel, next_bom_row] = _get_next_bom_row_smart(slave_bomlevel, _cb_get_bom_row);
          if (next_bom_row !== false) {
            slave_bomlevel = next_bomlevel; // for next iteration
            const virtel = next_bom_row;
            let bomlevel;
            if (mode_as_sibling === true) {
              // MODE INSERT AS SIBLING
              bomlevel = _merge_bomlevel_as_sibling(master_bomlevel, slave_bomlevel);
            } else {
              // MODE INSERT AS CHILDREN
              bomlevel = _merge_bomlevel_as_child(master_bomlevel, slave_bomlevel);
            }
            if (_is_next_bomlevel_valid(last_valid_bomlevel, bomlevel)) {
              // bomlevel will also be validated
              // everything valid
            } else {
              // ERROR: there is invalid next bomlevel
              console.log('INVALID next bomlevel:', last_valid_bomlevel, bomlevel)
              exit = true;
            }
            //
            if (true) { // bomlevel already validated
              const parent_bomlevel = _detect_parent_bomlevel(bomlevel);
              let parent_subkey = null;
              if (_is_bomlevel_valid(parent_bomlevel)) {
                const parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(virbom_ref, parent_bomlevel);
                if (parent_virtel !== false) {
                  parent_subkey = parent_virtel.subkey;
                }
              }
              const graphlevel = _detect_graphlevel(bomlevel);
              const graphpath = _virbom_manipulator._get_parent_graphpath_smart(virbom_ref, bomlevel) + SLASH + virtel.virtelschemakey; // ???
              let subkey = null;
              if (typeof _generate_fresh_subkey === 'function') {
                // Ukoliko je primljen callback _generate_fresh_subkey kao argment, onda pri merge-ovanju svi virteli iz slave_virbom_seq dobijaju nove subkey-eve.
                subkey = _generate_fresh_subkey();
              } else {
                // svi zadržavaju subkey-eve kakvi jesu
                subkey = virtel.subkey;
              }
              const new_virtel = {
                ...virtel,
                subkey,
                parent_subkey,
                bomlevel,
                graphlevel,
                graphpath,
              };
              // ADD THIS VIRTEL TO END
              _virbom_manipulator._record_virtel(virbom_ref, new_virtel);
              last_valid_bomlevel = bomlevel;
            }
          } else {
            exit = true;
            // ako ne postoji next_bom_row virtel
            exit = true; // zavrsili smo sa prolaskom kroz sve virtele od slave_virbom_seq
          }
          // REPEAT
        } // end of while
      } else {
        return false; // ERROR master_virtel not exist
      }
    } else {
      return false; // ERROR invalid master_bomlevel
    }
    //
    // FINISHED _merge_virbom_into_virbom_where_bomlevel
    return true;
  } else {
    return false; // ERROR One or both of the virboms are empty. Nothing to merge.
  }
  return false;
};


_virbom_manipulator._merge_virbom_into_virbom_on_graphlevel = (virbom_ref, slave_virbom_seq, graphlevel, _generate_fresh_subkey) => {
  if (_is_arr_not_empty(slave_virbom_seq)) {
    if (_is_arr_not_empty(virbom_ref)) { // CASE master virbom not empty
      const last_virtel = _virbom_manipulator.get_last_virtel(virbom_ref);
      if (last_virtel !== false && last_virtel.bomlevel) {
        const last_bomlevel = last_virtel.bomlevel;
        const last_graphlevel = _detect_graphlevel(last_bomlevel); // bomlevel will also be validated
        if (_is_graphlevel_valid(last_graphlevel) && _is_graphlevel_valid(graphlevel)) {
          // console.log('**** merge TEST graphlevel, last_graphlevel ***', graphlevel, last_graphlevel, graphlevel - last_graphlevel);
          //
          if (_is_next_graphlevel_valid(last_graphlevel, graphlevel)) {
            // Samo ako je graphlevel dozvoljen kao next. Ovo sprecava krešenje pravila virbom_sequence.
            // dozvoljeni grahlevel za novi virtel su sledeci:
            if (graphlevel === last_graphlevel) {
              // CASE add as sibling of last_virtel
              // console.log('merge on last_virtel - as sibling of', last_bomlevel);
              return _virbom_manipulator._merge_virbom_into_virbom_where_bomlevel(virbom_ref, last_bomlevel, true, slave_virbom_seq, _generate_fresh_subkey);
            } else if (graphlevel > last_graphlevel && (graphlevel - last_graphlevel) === 1) {
              // CASE add as children of last_virtel
              // console.log('merge on last_virtel - as child of', last_bomlevel);
              return _virbom_manipulator._merge_virbom_into_virbom_where_bomlevel(virbom_ref, last_bomlevel, false, slave_virbom_seq, _generate_fresh_subkey);
            } else if (graphlevel < last_graphlevel) {
              // CASE add as sibling on some of the ancestor of last_virtel
              const _ancestor_bomlevel = _detect_bomlevel_on_graphlevel(last_bomlevel, graphlevel);
              if (_is_bomlevel_valid(_ancestor_bomlevel)) {
                // console.log('merge on _ancestor_bomlevel - as sibling', _ancestor_bomlevel);
                return _virbom_manipulator._merge_virbom_into_virbom_where_bomlevel(virbom_ref, _ancestor_bomlevel, true, slave_virbom_seq, _generate_fresh_subkey);
              }
            } else {
              // u svim ostalim slucajevima nije dozvoljeno dodavanje virtela jer se moraju zadrzati pravila sekvence
              // trazeni graphlevel moze biti samo za 1 veci od last_virtel graphlevel sto znaci da je ONEMOGUĆENO da novi virtel preskoci redosled koji inace imamo pri tree traversingu.
              // Ako izvrsenke koda dodje ovde to znaci da je to pokusano.
              // will return false
            }
          } else {
            return false; // next_graphlevel is not allowed
          }
        } else {
          return false; // invalid graphlevel or invalid last_bomlevel
        }
      } else {
        return false; // ERROR invalid last_virtel
      }
    } else { // CASE master virbom is empty
      return _merge_virbom_into_empty_virbom(virbom_ref, slave_virbom_seq, _generate_fresh_subkey);
    }
  } else {
    return false; // ERROR Slave virbom is empty. Nothing to merge.
    // TODO Da li mozda ovo ipak treba da bude omoguceno?
  }
  return false;
};


// DETACH
_virbom_manipulator._detach_virbom_where_bomlevel = (virbom_seq, bomlevel) => {
  // NOVO NEISPROBANO
  // detach, segregate...
  // DOKUMENTACIJA: _detach_virbom_where_bomlevel odvaja (uzima) samo jednu granu grapha koja pocinje sa ciljanim bomlevel. Tacnije kreira novi virbom_seq kojeg ovde zovemo detached_virbom_seq u kojeg smesta samo jedan root virtel koji je taj ciljani i sve koji su hijerarhijski ispod njega.
  // Ukoliko ne postoji cak ni taj jedan virtel sa ciljanim bomlevel onda ce vratiti prazan detached_virbom_seq.
  //
  let detached_virbom_seq = [];
  if (_is_arr_not_empty(virbom_seq) && _is_bomlevel_valid(bomlevel)) {
    //
    const _cb_get_bom_row = (bomlevel) => {
      return _virbom_manipulator.get_virtel_where_bomlevel(virbom_seq, bomlevel);
    }
    //
    const detaching_graphlevel = _detect_graphlevel(bomlevel);
    let i_bomlevel = null; // inital
    let exit = false;
    while (exit === false) {
      console.log('i_bomlevel', i_bomlevel);
      const [next_bomlevel, next_bom_row] = _get_next_bom_row_smart(i_bomlevel, _cb_get_bom_row); // U inicijalnom slucaju kada je i_bomlevel===null next_bomlevel ce biti inicijalni "1".
      if (next_bom_row !== false) {
        i_bomlevel = next_bomlevel; // for next iteration
        const virtel = next_bom_row;
        if (bomlevel === i_bomlevel || _is_bomlevel1_ancestor_of_bomlevel2(bomlevel, i_bomlevel)) {
          // Samo ako je i_bomlevel kojeg trenutno razmatramo ili bas taj bomlevel kojeg ciljamo ili je hijerarhijski ispod njega.
          const detached_bomlevel = _detach_bomlevel(i_bomlevel, detaching_graphlevel);
          const detached_graphlevel = _detect_graphlevel(detached_bomlevel);
          if (_is_bomlevel_valid(detached_bomlevel)) {
            let parent_subkey = null;
            if (detached_graphlevel > 1) {
              const detached_parent_bomlevel = _detect_parent_bomlevel(detached_bomlevel);
              if (_is_bomlevel_valid(detached_parent_bomlevel)) {
                // on top graphlevel parent_bomlevel will alse be false
                const detached_parent_virtel = _virbom_manipulator.get_virtel_where_bomlevel(detached_virbom_seq, detached_parent_bomlevel);
                if (detached_parent_virtel !== false) {
                  parent_subkey = detached_parent_virtel.subkey;
                  // PITANJE: Da li ovo znaci da i detached virbom ima 
                }
              }
            }
            const new_virtel = {
              ...virtel,
              parent_subkey,
              bomlevel: detached_bomlevel,
              graphlevel: detached_graphlevel,
              graphpath: '***TODO',
            };
            // TODO ???
            // ADD THIS VIRTEL TO END
            // _virbom_manipulator._record_virtel(detached_virbom_seq, new_virtel); // TODO ???
          }
        }
      } else {
        // ako ne postoji next_bom_row virtel
        exit = true; // zavrsili smo prikupljanje detached_virbom_seq
      }
    } // end of while
    return detached_virbom_seq;
  }
  return false;
};

